import React from 'react';
import { StyledNuvoBox } from '#/common/styles/template';
import ColumnMapper, {
  OptionInfo,
  TargetField,
  SeparatorInfo,
} from '#/common/components/ColumnMapper';
import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';
import { NuvoLabel } from '@nuvolo/nuux-core/components/NuvoLabel';
import { WarningLabel } from '../styles';

export interface MandatoryFieldsStepBaseProps {
  csvColumns: OptionInfo[];
  mapping: Record<string, string>;
  setMapping: React.Dispatch<React.SetStateAction<Record<string, string>>>;
  targetDropdownSelections: Record<string, string>;
  setTargetDropdownSelections: React.Dispatch<React.SetStateAction<Record<string, string>>>;
  setIsValid: React.Dispatch<React.SetStateAction<boolean>>;
  mandatoryFields: TargetField[];
  uniqueFieldsMessage: string;
  uniqueFieldsMessageSeeMore: string;
  separators?: SeparatorInfo[];
  warningContent: React.ReactNode;
}

/**
 * Shared layout for the mandatory-fields mapping step (Asset, Work Order, ...). Entity-specific
 * field definitions and copy are supplied by the caller.
 */
const MandatoryFieldsStepBase: React.FC<MandatoryFieldsStepBaseProps> = ({
  csvColumns,
  mapping,
  setMapping,
  targetDropdownSelections,
  setTargetDropdownSelections,
  setIsValid,
  mandatoryFields,
  uniqueFieldsMessage,
  uniqueFieldsMessageSeeMore,
  separators,
  warningContent,
}) => {
  const { isDesktop } = useViewport();

  return (
    <StyledNuvoBox isDesktop={isDesktop}>
      <div className="box-caption">
        <NuvoLabel>Match Mandatory Columns</NuvoLabel>
      </div>
      {csvColumns.length === 0 ? (
        <NuvoLabel>Loading CSV columns...</NuvoLabel>
      ) : (
        <ColumnMapper
          sourceOptions={csvColumns}
          targetFields={mandatoryFields}
          mapping={mapping}
          setMapping={setMapping}
          targetDropdownSelections={targetDropdownSelections}
          setTargetDropdownSelections={setTargetDropdownSelections}
          setIsValid={setIsValid}
          uniqueFieldsMessage={uniqueFieldsMessage}
          uniqueFieldsMessageSeeMore={uniqueFieldsMessageSeeMore}
          sourceLabel="Your File Columns"
          targetLabel="TMM Columns"
          separators={separators}
        />
      )}
      <WarningLabel>{warningContent}</WarningLabel>
    </StyledNuvoBox>
  );
};

export default React.memo(MandatoryFieldsStepBase);
